// extracted by mini-css-extract-plugin
module.exports = {"dividerHorizontal":"Divider_dividerHorizontal__BICKs","dividerVertical":"Divider_dividerVertical__1Wm_T"};